import React from 'react'
import PropTypes from 'prop-types'
import { styled } from '@deseretbook/react-ui'

const StyledClickableContent = styled('div')(({ theme, isPaddingless = false, isDisabled = false }) => {
  const additionalStyles = {}

  if (isDisabled) {
    additionalStyles.opacity = 0.5
    additionalStyles.cursor = 'not-allowed'
  }
  
  return {
  label: 'ClickableContent',
  padding: isPaddingless ? 0 : theme.spacing.use(0.5),
  display: 'block',
  textDecoration: 'none !important',
  cursor: 'pointer',
  borderRadius: '4px',
  ...additionalStyles,
  '&:hover': {
    background: theme.palette.background.alternate,
  },
}})

/**
 * Adds styles to say "this content is clickable". Can use the `as` prop to make the component
 * a link.
 *
 * @param {object} props - Component props
 * @returns {function} Component
 */
export const ClickableContent = ({ as, ...props }) => {
  const Component = as ? StyledClickableContent.withComponent(as) : StyledClickableContent

  return <Component {...props} />
}

ClickableContent.propTypes = {
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
}

ClickableContent.defaultProps = {
  as: undefined,
}
